import {reducerWithInitialState} from "typescript-fsa-reducers";
import { footerInitialState, deepCopyGraphThingyState } from "../typing/states";
import {FooterThingyActions} from "../actions/actions";

export default reducerWithInitialState(footerInitialState)
        .case(FooterThingyActions.resetData, (state,payload) => {
            const deepCopy=deepCopyGraphThingyState(state);
            if (payload){
               deepCopy.version = payload.version;
            }
            return deepCopy;
        })
        ;